import { render } from "./Reload.vue?vue&type=template&id=6dd363f2"
import script from "./Reload.vue?vue&type=script&lang=js"
export * from "./Reload.vue?vue&type=script&lang=js"
script.render = render

export default script